<template>
  <div :class="name">
    <div :class="`${name}__audience`">
      <skeleton-basic width="160px" height="22px" style="margin-bottom: 32px;" />
      <skeleton-basic width="45px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="556px" height="34px" style="margin-bottom: 24px;" />
      <skeleton-basic width="45px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="556px" height="34px" />
    </div>
    <div :class="`${name}__demographics`">
      <skeleton-basic width="106px" height="22px" style="margin-bottom: 32px;" />
      <!-- location  -->
      <skeleton-basic width="70px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="480px" height="46px" style="margin-bottom: 8px;" />
      <skeleton-basic width="480px" height="34px" style="margin-bottom: 32px;" />
      <!-- gender -->
      <skeleton-basic width="46px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="191px" height="34px" style="margin-bottom: 32px;" />
      <!-- age -->
      <skeleton-basic width="25px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="435px" height="34px" style="margin-bottom: 32px;" />
      <!-- language -->
      <skeleton-basic width="85px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="480px" height="34px" />
    </div>
    <div :class="`${name}__interests`">
      <skeleton-basic width="154px" height="22px" style="margin-bottom: 32px;" />
      <skeleton-basic width="676px" height="92px" />
      <skeleton-basic width="676px" height="70px" style="margin-top: 8px;" />
      <skeleton-basic width="676px" height="70px" style="margin-top: 8px;" />
      <skeleton-basic width="676px" height="70px" style="margin-top: 8px;" />
      <skeleton-basic width="676px" height="70px" style="margin-top: 8px;" />
    </div>
    <div :class="`${name}__device`">
      <skeleton-basic width="50px" height="22px" style="margin-bottom: 32px;" />
      <!-- os -->
      <skeleton-basic width="108px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="187px" height="34px" style="margin-bottom: 32px;" />
      <!-- os-version -->
      <skeleton-basic width="74px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="480px" height="34px" style="margin-bottom: 32px;" />
      <!-- device-model -->
      <skeleton-basic width="85px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="480px" height="34px" style="margin-bottom: 32px;" />
      <!-- connect-type -->
      <skeleton-basic width="100px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="300px" height="34px" style="margin-bottom: 32px;" />
      <!-- carriers -->
      <skeleton-basic width="48px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="480px" height="34px" style="margin-bottom: 32px;" />
      <!-- device-price -->
      <skeleton-basic width="77px" height="22px" style="margin-bottom: 14px;" />
      <skeleton-basic width="115px" height="22px" style="margin-bottom: 10px;" />
      <skeleton-basic width="115px" height="22px" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';
const name = 'ttam-targeting-skeleton';

export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  setup() {
    return {
      name,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-targeting-skeleton';

.#{$name} {
  &__audience,
  &__demographics,
  &__interests {
    margin-bottom: 32px;
  }
}
</style>
